import { FC } from 'react'
import { useAppType } from '@/shared/contexts/AppTypeContext'
import { isLegacyApp } from '@/types/appType'
import { isEmbeddedContext } from '@/features/anycompass'
import LegacyIndexPage from '@/apps/legacy/pages/index'
import LatestIndexPage from '@/apps/latest/pages/index'

// AppType dispatcher (= legacy / latest).
// 設計: hub log/33 design/11_use_legacy_ui_app_type_architecture.md.
// custom_setting.use_legacy_ui を読み LEGACY (= default True) / LATEST に振り分け.

const IndexPage: FC = () => {
  const { appType } = useAppType()
  const legacy = isLegacyApp(appType)
  // AnyCOMPASS 埋め込みの防波堤 (患者突合ガード・転記・頭書き同期) は latest にしか
  // 無い。埋め込み店舗は use_legacy_ui=False が運用上の必須 (log/193) で、legacy へ
  // 落ちると全て消えるため、調査の足がかりとして warn を残す (UI は変えない)。
  if (legacy && isEmbeddedContext()) {
    console.warn(
      '[anycompass-embed] legacy UI で埋め込み表示されています。患者突合ガード・転記・頭書き同期は動作しません (use_legacy_ui=False が必要)'
    )
  }
  return legacy ? <LegacyIndexPage /> : <LatestIndexPage />
}

export default IndexPage
